import { Card } from 'antd';
import RecipeDetails from 'app/containers/Recipe/parts/RecipeDetails/RecipeDetails';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useResponsiveQuery } from 'utils/responsiveQuery/useResponsiveQuery';
import {
  selectTaskDetailsState,
  selectUsedTaskResourcesArrLength,
} from '../../slice/selectors';
import TaskCompaniesUsedResourcesTable from '../TaskCompaniesUsedResourcesTable/TaskCompaniesUsedResourcesTable';
import TaskPlannedResourcesTable from '../TaskPlannedResourcesTable/TaskPlannedResourcesTable';
import TaskUsedResourcesTable from '../TaskUsedResourcesTable/TaskUsedResourcesTable';

interface IProps {}

const TaskResourcesCard: FC<IProps> = () => {
  const { t } = useTranslation();
  const { mobileOrTablet } = useResponsiveQuery();

  const { task } = useSelector(selectTaskDetailsState);
  const usedResourcesArrLength = useSelector(selectUsedTaskResourcesArrLength);

  const isRecommendation =
    task?.status === 'RECOMMENDED' ||
    task?.status === 'ACCEPTED' ||
    task?.status === 'DECLINED';

  return (
    <>
      <Card
        bordered={false}
        title={t(
          'Task.ResourcesCard.PlannedTaskResources',
          'Planned task resources',
        )}
        style={{
          overflow: 'auto',
          maxHeight: mobileOrTablet ? 'unset' : 'calc(100vh - 170px)',
          maxWidth: '100%',
        }}
        bodyStyle={{
          paddingLeft: mobileOrTablet ? 6 : undefined,
          paddingRight: mobileOrTablet ? 6 : undefined,
          height: mobileOrTablet ? undefined : 'calc(100vh - 230px)',
          overflow: 'auto',
        }}
      >
        <div
          style={{
            marginBottom: 20,

            width: '100%',
          }}
        >
          <RecipeDetails
            recipe={task?.recipe}
            withResourceTable={false}
            withTitle={true}
            withDescription={false}
            recommendationCreator={task?.recipe?.createdBy}
          />
        </div>

        <TaskPlannedResourcesTable loading={false} isPrice={isRecommendation} />
      </Card>
      {Boolean(usedResourcesArrLength) && (
        <>
          <Card
            bordered={false}
            title={t('Task.ResourcesCard.UsedResources', 'Used resources')}
            style={{
              marginTop: 12,
              overflow: 'auto',
              maxWidth: '100%',
            }}
            bodyStyle={{
              paddingLeft: mobileOrTablet ? 6 : undefined,
              paddingRight: mobileOrTablet ? 6 : undefined,
              overflow: 'auto',
            }}
          >
            <TaskUsedResourcesTable />
          </Card>

          <Card
            bordered={false}
            title={t(
              'Task.ResourcesCard.UsedCompaniesResources',
              'Used companies resources',
            )}
            style={{ marginTop: 12 }}
          >
            <TaskCompaniesUsedResourcesTable loading={false} />
          </Card>
        </>
      )}
    </>
  );
};

export default TaskResourcesCard;
